import { createSlice, PayloadAction } from '@reduxjs/toolkit';


const initialState: any = {
  profileStepNo: 0
};

export const profileStepNoSlice = createSlice({
  name: 'profileStepNo',
  initialState,
  reducers: {
    setProfileStepNo: (state, action: PayloadAction<number>) => {
      state.profileStepNo = action.payload;
    }
  }
});

export const { setProfileStepNo } = profileStepNoSlice.actions;

export default profileStepNoSlice.reducer;
